import React, { useState, useEffect } from "react";
// import theme from 'theme';
import PropTypes from "prop-types";
import { TableDividend, TableEarning } from "./components";
import Tabs from "components/Tabs";
import { connect } from "react-redux";
import * as actions from "redux/actions/discoverActions";
import { Translate, I18n } from "react-redux-i18n";

// const useStyles = {
//     root: {
//         padding: theme.spacing(3),
//     },
//     content: {
//         marginTop: theme.spacing(2),
//     },
// };

const Discover = (props) => {

    const { className, history, ...rest } = props;
    const [list, setList] = useState(props.list);

    // style={useStyles.root}
    return (
        <div className="discover-page" >
            <div className="discover-header">
                <div>
                    <h1 className="discover-title">
                        {I18n.t("discover")}
                    </h1>
                    <p className="discover-subtitle">
                        Scan upcoming dividends and earnings to find new opportunities.
                    </p>
                </div>
            </div>
            <div className="discover-card">
                <div className="discover-content">
                     {/* <input
              type="text"
              name="search"
              className="discover-filter-input"
              placeholder="Filter by symbol, name or exchange"
              // value={filters.search}
              // onChange={handleFilterChange}
            /> */}
                    <Tabs>
                        <div label={I18n.t("dividend")} className="col-12">
                            <TableDividend list={props.list} />
                        </div>
                        <div label={I18n.t("earnings")} className="col-12">
                            <TableEarning list={props.list} />
                        </div>
                    </Tabs>
                    <div className="discover-filters-row">
           
          </div>
                </div>
            </div>
        </div>
    );
};

Discover.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};

function mapStateToProps(reducer) {
    //console.log(reducer);  <Toolbar history={history} />
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.discover.list,
        error: reducer.discover.error,
        loading: reducer.discover.loading,

        // search: reducer.history.search,
    };
}
const mapDispatchToProps = dispatch => ({
    loadListDividend: (params, token) =>
        dispatch(actions.loadListDividend({ params, token })),
    loadListEarning: (params, token) =>
        dispatch(actions.loadListEarning({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Discover);